import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import useGetUserSettingWithPreference from '../../../../common/category/useGetUserSettingWithPreference'
import { positionDropdown } from '../../../../common/dropdown'
import { Checkbox } from '../../../../common/html/checkbox'
import { Element } from '../../../../common/html/element'
import { SelectCustom } from '../../../../common/selectCustom'
import { CURRENCY } from '../../../../utils/currency'
import { changeCurrencies, selectCurrencies } from '../store/slice'

export const Currency = () => {
  const dispatch = useDispatch()

  const { userSettings } = useGetUserSettingWithPreference(true)
  const currencies = useSelector(selectCurrencies)

  useEffect(() => {
    if (!currencies.length) {
      dispatch(changeCurrencies([userSettings.currency]))
    }
  }, [currencies])

  return (
    <Element className="dFlex alignItemsEnd">
      &nbsp;
      <Element className="dFlex" style={{ fontSize: 12 }}>
        <Element className="fw400 whiteSpaceNowrap">
          <Translate value="screening.CURRENCY" />:
        </Element>
        <Element>
          <SelectCustom
            data={Object.values(CURRENCY).map((currency) => ({
              value: currency,
              label: currency,
            }))}
            renderActiveItem={() => (
              <span className="whiteSpaceNowrap">{currencies.join(', ')}</span>
            )}
            renderDropdownItem={(item) => (
              <CurrencyItem item={item} currencies={currencies} />
            )}
            style={{
              border: 'none',
              padding: '0 24px 0px 6px',
            }}
            minWidthDropdownEqualSelect={false}
            dropdownPosition={positionDropdown.BOTTOM_END_LEFT}
          />
        </Element>
      </Element>
    </Element>
  )
}

const CurrencyItem = ({ item, currencies }) => {
  const dispatch = useDispatch()

  const onChange = (isCheck) => {
    if (isCheck) {
      dispatch(changeCurrencies([...currencies, item.value]))
    } else {
      const newCurrencies = currencies.filter((i) => i !== item.value)
      if (newCurrencies.length === 0) return
      dispatch(changeCurrencies(currencies.filter((i) => i !== item.value)))
    }
  }

  return (
    <div
      className="mx1"
      style={{
        padding: '5px 0px',
        borderBottom: item.value !== CURRENCY.EUR ? '1px solid #d5d5d5' : '',
      }}
    >
      <Checkbox
        checked={currencies.includes(item.value)}
        onChange={onChange}
        title={item.label}
        isCheckOnClickText
      />
    </div>
  )
}
